import { Attendee } from '../../models/Attendee'

export function getAttendeeByUserUuid(userUuid: string, attendees: Attendee[]): Attendee | null {
  return attendees.find((attendee: Attendee) => attendee.booking.userUuid === userUuid) || null
}

export function getAttendeeStatus(userUuid: string, attendees: Attendee[] | undefined): boolean | null {
  const attendee = attendees?.find((attendee: Attendee) => attendee.booking.userUuid === userUuid)

  return attendee ? attendee.attended : null
}
